<template>
<div>
  <v-dialog v-model="dialog"  max-width="600px" persistent>
    <v-card flat>
      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="cNowSearchkeyWord"
              @keyup.enter="GetManagerInfo()"
              @click:append="GetManagerInfo()"
              placeholder="관리자 이름"
              label="검색어"
              class="mr-8"
              append-icon="search"
              persistent-placeholder
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <div style="height:calc(80vh - 230px);">
          <v-data-table
            :items="Records"
            :headers="headers"
            :single-select="bSingleSelect"
            show-select
            v-model="selected"
            @click:row="handleClick"
            @dblclick:row="handleDoubleClick"
            item-key="cCustomId"
            fixed-header
            height="calc(80vh - 280px)"
          >
            <template v-slot:item.data-table-select="{ isSelected }">
              <v-icon class="ml-0 pl-0" v-if="isSelected">done</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="black--text">{{cNoMsg}}</div>
            </template>
          </v-data-table>
        </div>
        <v-divider class="mt-8"></v-divider>
      </v-card-text>
      <div class="ml-7 text-caption">* 해당항목을 더블클릭으로 선택하세요.</div>  
      <v-divider class="ml-6 mr-6 mt-4"></v-divider>
      <v-card-actions class="pb-3 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false;" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
        <v-btn @click="handleDoubleClick()" width="90px" dark class="mr-2"><v-icon class="mr-2">mdi-check</v-icon>확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import { mapState } from "vuex";
import EventBus from '@/eventBus.js';

export default {
  components: {
  },

  data: () => ({
    dialog : false,
    bSingleSelect : true,
    cNowSearchkeyWord : "",
    cManager : "",
    cNoMsg : "",
    selected: [],
    Records: [],
    headers: [
      { text: '직원 이름', align: 'center', value: 'cCustomNm'},
      { text: '이메일', value: 'cEmail'},
      { text: '전화번호', value: 'cTel'},
      { text: '대표전화번호', value: 'cPresentTel'},
    ],
  }),
      
  computed: {
    ...mapState(["CustomInfo"]),
  },
  
  created() {
  },

  methods: {
    ShowDialog(item) {
      this.dialog = true
      this.selected = []
      this.cManager = item.cManagerState
      this.cNowSearchkeyWord = item.cChangeCustomNm
      this.GetManagerInfo();
    },

    handleClick(value) {
      this.selected = [value];
    },

    async handleDoubleClick() {
      if (this.selected.length == 0) {
        return EventBus.$emit("onShowMsgBox","관리자 선택이 제대로 되지 않았습니다.",  "관리자를 선택 후 우측의 확인 버튼을 클릭해 주세요.");
      } else {
        this.dialog = false;
        this.cManager = ""
        this.cNowSearchkeyWord = ""
        EventBus.$emit("onShowMsg",false,"관리자를 선택 하셨습니다.");
        this.$emit("SelectManager",this.selected[0])
      }
    },

    GetManagerInfo(){
      this.cNoMsg = ""

      var posData = {
        // this.CustomInfo.Token
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        CustomNm : this.cNowSearchkeyWord,
        Manager : this.cManager,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetManagerInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.Records = res.data.Result

            if (this.Records.length == 0) {
              setTimeout(() => {
                this.cNoMsg = "조회된 관리자가 없습니다."
              }, 300);
            }
          } else {
            this.dialog = false;
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);

          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
};
</script>

<style>

</style>
